import { useQuery } from '@tanstack/react-query';

import { fetchAuditLogs } from './audit-logs.api';
import type { AuditLogFilters } from './types';

export const useAuditLogs = (filters: AuditLogFilters) =>
  useQuery({
    queryKey: ['audit-logs', filters],
    queryFn: () => fetchAuditLogs(filters),
  });
